import {motion, AnimatePresence} from 'framer-motion';
import logo from '../components/assets/logo.png';
import LoginCard from "../components/LoginCard";
import PassIdCard from '../components/PassIdCard';
import PassQuestionCard from '../components/PassQuestionCard';
import PassNewPassCard from '../components/PassNewPassCard';
import { useContext, useEffect } from 'react';
import GeneralContext from '../context/GeneralContext';

function Index() {

    const {
        activeMode,
        changeModalClass,
        delayTimer,
        setDelayTimer,
        resizeIndex,
        growingWidth,
        resizeOnload,
        animationDuration,
        animationDelay
    } = useContext(GeneralContext);

    const disappearShapeDivider = () => {
        const divider = document.getElementById('loginDivider');
        divider.style.animation = 'disappear 1s';
        divider.addEventListener("animationend", function finAnimacion () {
            divider.removeEventListener("animationend", finAnimacion);
            divider.remove();
        })
    }

    window.addEventListener("resize", resizeIndex);
    window.innerWidth < 800 ? growingWidth.current ='100vw' : growingWidth.current = '50vw';

    useEffect(() => {
        document.getElementById('rightSplashScreen').style.width = 0;
        resizeOnload();
        changeModalClass('button');
        setDelayTimer(3);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="doubleColumnLogin">
            <motion.div
            key='leftColumnIndex'
            className="centeredDiv"
            initial={{opacity: 0, scale: 0.5}}
            animate={{opacity: 1, scale: 1.2}}
            exit={{y: 500, opacity: 0, scale: 1}}
            transition={{duration: 1}}>
                <img src={logo} alt='logo' className='logo' />
            </motion.div>
            <motion.div
            id="rightSplashScreen"
            key='rightColumnIndex'
            initial={{maxWidth: '0vw', width: '0vw'}}
            animate={{maxWidth: growingWidth.current, width: growingWidth.current}}
            exit={{maxWidth: '0vw', width: '0vw'}}
            transition={{duration: animationDuration.current, delay: animationDelay.current}}>
                <motion.div
                key='rightColumnContent'
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{y: -500, opacity: 0, transition: {delay: 0}}}
                transition={{duration: 1, delay: 2.5}}>
                    <h1 style={{textAlign: 'center', marginTop: '-7vh', color: 'white'}}>Sistema de Puntos</h1>
                    <AnimatePresence>
                        {activeMode === 'login' ?
                            <motion.div
                            key='loginMenu'
                            initial={{opacity: 0, maxHeight: '0vh'}}
                            animate={{opacity: 1, maxHeight: '60vh'}}
                            exit={{opacity: [1, 0], maxHeight: ['60vh', '0vh'], transition: {delay: 0}}}
                            transition={{duration: 1, delay: delayTimer}}>
                                <LoginCard additionalFunction={disappearShapeDivider} />
                            </motion.div> : null
                        }
                        {activeMode === 'password' ?
                            <motion.div
                            key='passwordMenu'
                            initial={{opacity: 0, maxHeight: '0vh'}}
                            animate={{opacity: 1, maxHeight: '60vh'}}
                            exit={{opacity: 0, maxHeight: ['60vh', '0vh'], transition: {delay: 0}}}
                            transition={{duration: 1, delay: 1}}>
                                <PassIdCard additionalFunction={disappearShapeDivider} />
                            </motion.div> : null
                        }
                        {activeMode === 'question' ?
                            <motion.div
                            key='questionMenu'
                            initial={{opacity: 0, maxHeight: '0vh'}}
                            animate={{opacity: 1, maxHeight: '60vh'}}
                            exit={{opacity: 0, maxHeight: ['60vh', '0vh'], transition: {delay: 0}}}
                            transition={{duration: 1, delay: 1}}>
                                <PassQuestionCard />
                            </motion.div> : null
                        }
                        {activeMode === 'newpass' ?
                            <motion.div
                            key='newPassMenu'
                            initial={{opacity: 0, maxHeight: '0vh'}}
                            animate={{opacity: 1, maxHeight: '60vh'}}
                            exit={{opacity: 0, maxHeight: ['60vh', '0vh'], transition: {delay: 0}}}
                            transition={{duration: 1, delay: 1}}>
                                <PassNewPassCard />
                            </motion.div> : null
                        }
                    </AnimatePresence>
                </motion.div>
                <div className="custom-shape-divider-bottom-1707185247" id="loginDivider">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
                        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
                        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
                    </svg>
                </div>
            </motion.div>
        </div>
    )
}

export default Index